import {
  createSentryExceptionHandler,
  createSentryReactClient,
  SentryEnvironment,
} from '@chocoapp/toolbelt-utils';

import { COMMIT_SHA, SENTRY_DSN, SENTRY_ENV } from '../config';
import { APP_BROWSER_HISTORY } from '../constants/AppConstants';

export const Sentry = createSentryReactClient({
  appName: 'choco-web',
  sentryDSN: SENTRY_DSN,
  sentryEnv: SENTRY_ENV as SentryEnvironment,
  commitSHA: COMMIT_SHA,
  appBrowserHistory: APP_BROWSER_HISTORY,
});

export const captureSentryException = createSentryExceptionHandler({
  client: Sentry,
  sentryEnv: SENTRY_ENV as SentryEnvironment,
});

type ErrorOptions = { cause: Error };

class SentryError extends Error {
  constructor(public message: string, public cause: ErrorOptions) {
    super(message);

    this.cause = cause;
  }
}

export const captureSentryExceptionWithScope = (
  error: Error,
  errorMessagePrefix: string
): void => {
  Sentry.withScope(scope => {
    const errorMessage = `${errorMessagePrefix}: ${JSON.stringify(
      error.message
    )}`;

    scope.setFingerprint([errorMessage]);
    captureSentryException(new SentryError(errorMessage, { cause: error }));
  });
};
